export default {
  getComments: (state) => state.comments.list.items,
  getCommentsPaginationData: (state) => state.comments.list.meta,
  getCommentsIsFetching: (state) => state.comments.list.isFetching,
};
